// Main js file for the object
function home() {
  console.log('home');
}

export default home;
